// extracted by mini-css-extract-plugin
export default {"login-button--only-icon":"VU1qBI","login-button--with-user":"YtIvqx","login-text":"vXoGg1"};